import React from 'react'
import { shallowEqual, useDispatch, useSelector } from 'react-redux'
import { Button, Icon, Typography } from 'gu-ui-kit'
import { TOGGLE_PANEL } from 'modules/Tickets/types'
import styles from 'components/Header/subcomponents/TicketsCounter/ticket-notifications.module.scss'
import { useTranslation } from 'react-i18next'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { SET_DRAWER_STATE } from 'modules/App/types'

const TicketsCounter = ({ className }) => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const { ticketsCounter = 0 } = useSelector(
    (state) => ({
      ticketsCounter: state.notifications?.counters?.ticket,
    }),
    shallowEqual,
  )

  return (
    <Button
      className={clsx(styles['tickets-button'], className)}
      variant={'ghost'}
      grey
      size={'s'}
      title={t('tickets::header')}
      startIcon={<Icon name={'messages'} />}
      onClick={() => {
        dispatch({ type: SET_DRAWER_STATE, payload: { opened: false } })
        dispatch({ type: TOGGLE_PANEL, payload: true })
      }}
      additionalIcon={
        ticketsCounter > 0 && (
          <Typography
            variant={'Body-10'}
            component={'span'}
            className="unread"
          >
            {ticketsCounter}
          </Typography>
        )
      }
    />
  )
}

export default TicketsCounter

TicketsCounter.propTypes = {
  className: PropTypes.string,
}
